import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./filtered_search/event_hub.js